import { digObject, generateRedirectUrl } from '@domain-group/javascript-utils'

import useTeamMember, { useRelations, useTeamMemberForm } from '@hooks/useTeamMember'
import useTeamMembers from '@hooks/useTeamMembers'
import { generateUrls } from '@hooks/useUser'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import { adminMemberRoles } from '@functions/teamMember'

import { TeamMemberModel, UserModel } from '@models/types'

const getManageUserTeamMemberRolesUrl = (user: UserModel, editUserUrl: string) => {
  const payload = encodeURIComponent(JSON.stringify({ user: { id: user?.id } }))
  const redirect = generateRedirectUrl()
  const showModal = 'ManageUserTeamMemberRolesModal'

  return `${editUserUrl}?redirect=${redirect}&showModal=${showModal}&showModalPayload=${payload}`
}

const filteredAdminMemberRoles = (user: UserModel) => {
  const allowedMemberRoles = digObject(user, 'data.allowed_team_member_roles', [])
  const filteredAdminRoles = adminMemberRoles.filter(
    adminMemberRole => allowedMemberRoles.includes(adminMemberRole.key),
  )

  return filteredAdminRoles
}

const useCreateOrEditAdminTeamMemberModal = (teamMember: Partial<TeamMemberModel> = {}) => {
  const teamMemberPayload = useTeamMembers({
    filters: { team_id: teamMember.team_id },
    requestOptions: defaultRequestOptions.teamMember,
  })

  const { filteredTeamMembers } = teamMemberPayload

  const {
    callbacks: teamMemberCallbacks,
    creating,
    updating,
  } = useTeamMember(teamMember)

  const teamMemberFormPayload = useTeamMemberForm(teamMember, { validateOn: 'change' })
  const {
    entityState: {
      user_id: teamMemberUserId,
    },
  } = teamMemberFormPayload

  // @ts-expect-error TS2345
  const { user } = useRelations({ user_id: teamMemberUserId })
  const { editUserUrl } = generateUrls(user)

  // @ts-expect-error TS2345
  const allowedTeamMemberRoles = filteredAdminMemberRoles(user)
  const hasTeamLeadRoles = allowedTeamMemberRoles.some(memberRole => memberRole.group === 'team_lead')
  const hasSupportRoles = allowedTeamMemberRoles.some(memberRole => memberRole.group === 'support')

  return (
    {
      allowedTeamMemberRoles,
      callbacks: {
        ...teamMemberCallbacks,
      },
      creating,
      filteredTeamMembers,
      hasSupportRoles,
      hasTeamLeadRoles,
      teamMemberFormPayload,
      updating,
      urls: {
        // @ts-expect-error TS2345
        manageUserTeamMemberRolesUrl: getManageUserTeamMemberRolesUrl(user, editUserUrl),
      },
    }
  )
}

export default useCreateOrEditAdminTeamMemberModal
